import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';
import * as helpers from '../helpers';

/**
 * @param {{ translate: Function }|{ tkPrefix: String }} [options]
 * @returns {(error: any, defaultMessage?: String) => String}
 */
export const useGetErrorMessage = ({ translate: customTranslate, tkPrefix } = {}) => {
    const componentTranslate = useComponentTranslations();
    const translateWithCustomTK = useTranslations(tkPrefix);
    const translate = customTranslate || tkPrefix && translateWithCustomTK || componentTranslate;

    return useCallback((error, defaultMessage) => {
        const { userError, errorCode } = helpers.getUserError(error);

        return userError || translate(`error.${errorCode}`, defaultMessage ?? translate('playtech.mobile.system.systemError'));
    }, [translate]);
};
